import { render, staticRenderFns } from "./saleInfo.vue?vue&type=template&id=b594e08a"
import script from "./saleInfo.vue?vue&type=script&lang=js"
export * from "./saleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports